import logoDark from "../../../../brand/klantpunt/logo-wit.svg";
import logoLight from "../../../../brand/klantpunt/logo.svg";

/** Klantpunt-logo dat meewisselt met het thema (wit op donker, verloop met donkere tekst op licht). */
export function Logo({ className = "logo" }: { className?: string }) {
  return (
    <>
      <img src={logoDark} alt="Klantpunt" className={`${className} logo-dark`} />
      <img src={logoLight} alt="Klantpunt" className={`${className} logo-light`} />
    </>
  );
}
